import { ref } from "vue";

export const loadPage = ref(true)
